import React from 'react';
import classes from './style.module.scss';

const BottomPopup = ({ show, onClose, children }) => {
  if (!show) return null;

  return (
    <div className={classes['popup-overlay']} onClick={onClose}>
      <div className={classes['popup-container']} onClick={e => e.stopPropagation()}>
        <div className={classes['popup-body']}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default BottomPopup;
